interface ChannelParams {
  userId?: string;
  tenantId: string;
  jobId?: string;
  discoveryId?: string;
}

const ChannelNames = {
  NOTIFICATIONS: ({ userId, tenantId }: ChannelParams): string =>
    `private-notifications-${userId}@${tenantId}`,
  AUTH: ({ userId, tenantId }: ChannelParams): string =>
    `private-auth-${userId}@${tenantId}`,
  JOBS: ({ jobId, tenantId }: ChannelParams): string =>
    `private-jobs-${jobId}@${tenantId}`,
  DISCOVERY_NOTES: ({ discoveryId, tenantId }: ChannelParams): string =>
    `private-discovery-notes-${discoveryId}@${tenantId}`,
  CURRENT_CONFIGURATION: ({ tenantId }: ChannelParams): string =>
    `private-current-configuration@${tenantId}`,
  ENGAGEMENT: ({ tenantId }: ChannelParams): string =>
    `private-engagement@${tenantId}`,
  SALESFORCE_INSTALLATION: ({ tenantId }: ChannelParams): string =>
    `private-salesforce-installation@${tenantId}`,
  SSO_INSTALLATION: ({ tenantId }: ChannelParams): string =>
    `private-sso-installation@${tenantId}`,
  DISCOVERY: ({ discoveryId, tenantId }: ChannelParams): string =>
    `private-discovery-${discoveryId}@${tenantId}`
};

export default ChannelNames;
